if(!customElements.get("account-modal")) {
  customElements.define("account-modal", class AccountModal extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.classList.remove("hidden");

      this.overlay = this.querySelector(".account-modal__overlay");
      this.overlay.addEventListener("click", this.close.bind(this));

      this.closeBtn = this.querySelector("#closeBtn");
      this.closeBtn.addEventListener("click", this.close.bind(this));
    }

    open() {
      this.setAttribute("open", "");
    }

    close() {
      this.removeAttribute("open");
    }
  });
}
